import styles from "./DisruptorBlock.module.scss";
import classNames from "classnames/bind";
import { ESIInclude } from "@packages/esi-include/SimpleESIInclude";

const cx = classNames.bind(styles);

export type DisruptorBlockDetails = {
  id?: string;
  gridIndex: number;
  maxWidth: number;
  esiPath?: string;
};

export const DisruptorBlock = ({
  disruptorBlockDetails: { id, maxWidth, esiPath },
  className,
}: {
  disruptorBlockDetails: DisruptorBlockDetails;
  className?: string;
}) => {
  return (
    <div
      data-component="DisruptorBlock"
      data-disruptor-block={id}
      data-testid="disruptor-block"
      className={cx(
        "disruptor-block",
        `disruptor-block--${maxWidth}-span`,
        className,
      )}
    >
      {esiPath && (
        <ESIInclude src={esiPath} id="web-plp-scaffold-ui-disruptor-block" />
      )}
    </div>
  );
};
